import { CrudModel } from "../plugins/Cruxtify/CrudModel";
import { CrudFieldQuery } from "../plugins/Cruxtify/CrudField";

export class ApcCrudModel extends CrudModel {
  protected userIdField: CrudFieldQuery[] = [];
}
